import React from 'react';
import {VideoBoxProps} from './VideoBox.props';
import './VideoBox.styles.css';

export const VideoBox: React.FC<VideoBoxProps> = ({componentId}) => {
  return <div id={componentId} className="videobox-style" />;
};
